import React, { Component } from 'react';
import styled from 'styled-components';
import { colors } from '../utils/helpers';
import CountUp from 'react-countup';

export default class ClaveMapa extends Component {
	render() {
		const Clave = styled.div`
	font-size: 1em;
	padding: 0.5em;
	background: ${colors.white};
	border-bottom: solid 1px ${colors.alto};
	// background: ${colors.alto};
`;

		const ContClave = styled.div`
			margin: 0 auto;
			display: flex;
			justify-content: space-around;
			transform: translateX(10px);
			max-width: 350px;
		`;

		const NombreProcesion = styled.h1`
			font-size: 1.6em;
			font-weight: 500;
			text-align: left;
			padding: 1em 0 1em 0;
			margin: 0;
			text-align: center;
			font-family: ${colors.stackSerif};
			color: ${colors.grisoscuro};
		`;

		const Ida = styled.p`
			font-size: 0.9em;
			display: inline-block;
			margin: 0 0 0.8em 0;
			&:before {
				width: 35px;
				border-top: 4px solid ${colors.ss};
				content: '';
				display: inline-block;
				vertical-align: middle;
				transform: translateX(-10px);
				border-radius: 2px;
			}
		`;

		const Vuelta = Ida.extend`
			&:before {
				border: 0;
				height: 4px;
				background: url(data:image/svg+xml,%3Csvg%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2035.2%204%22%3E%3Cstyle%3E.st0%7Bfill%3A%23a94623%7D%3C/style%3E%3Cpath%20class%3D%22st0%22%20d%3D%22M12.5%200h10.3v4H12.5zM8.5%200H2C.9%200%200%20.9%200%202s.9%202%202%202h6.5V0zM33.3%200h-6.5v4h6.5c1.1%200%202-.9%202-2s-.9-2-2-2z%22/%3E%3C/svg%3E);
			}
		`;

		const Numero = styled.strong`
			min-width: 70px;
			display: inline-block;
		`;

		const countOptions = {
			useEasing: true,
			useGrouping: true,
			separator: '.',
			decimal: ''
		};

		return (
			<div className="container missed">
				<Clave>
					<NombreProcesion> {this.props.nombre} </NombreProcesion>{' '}
					<ContClave>
						<Ida>
							Ida:{' '}
							<Numero>
								{' '}
								{
									<CountUp
										{...countOptions}
										start={1000}
										end={this.props.distancia[0]}
										duration={0.6}
									/>
								}{' '}
								m.{' '}
							</Numero>{' '}
						</Ida>{' '}
						<Vuelta>
							Vuelta:{' '}
							<Numero>
								{' '}
								{
									<CountUp
										{...countOptions}
										start={1000}
										end={this.props.distancia[1]}
										duration={0.6}
									/>
								}{' '}
								m.{' '}
							</Numero>{' '}
						</Vuelta>{' '}
					</ContClave>{' '}
				</Clave>{' '}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/ClaveMapa.js